<div
  class="display-flex flex-column h-100 turnover-empty-data-container align-items-center justify-content-center grid-gap-20"
>
  <app-icon [svg]="icon" [iconWidth]="120" [iconHeight]="120"></app-icon>
  <h3 class="display-flex">{{ header }}</h3>
  <div>{{ info }}</div>
</div>
